<template lang='pug'>
  form#login(autocomplete="off", @submit.prevent="login" method="post")
    b-form-group
      vm-input(icon='email-outline', :placeholder='$t("login.email")' v-model="form.email", required, autofocus)
      span.help-block(v-if='authError')
        strong {{ $t('auth.failed') }}

    b-form-group
      vm-input(type="password", icon='lock-outline', :placeholder='$t("login.password")' v-model="form.password", required)

    b-form-group#boxes
      .d-flex.justify-content-between
        vm-checkbox(v-model='form.rememberMe') {{ $t('login.keep_connected') }}

        router-link.content-vertical.text-secondary(to='/password/reset') {{ $t('login.forgot_password') }}

    b-form-group
      vm-button#loginButton.vm-con-loading__container(color="primary", type="filled") {{ $t('login.login') }}
</template>

<script>
import formValidation from '@/utils/formValidations'
import { mapActions } from 'vuex'

export default {
  name: 'login',
  data () {
    return {
      form: {
        email: null,
        password: null,
        rememberMe: false
      },
      authError: false
    }
  },
  methods: {
    ...mapActions({
      loadData: 'loadData',
      setAlertMessage: 'setAlertMessage'
    }),
    async doLogin () {
      await this.$auth.login({
        data: this.form,
        success (response) {
          const { status } = response
          if (status === 401) {
            this.authError = true
          }
          this.loadData()
        },
        rememberMe: this.form.rememberMe,
        redirect: '/'
      }).catch(error => {
        this.setAlertMessage({ color: 'danger', title: 'errors.connection_error', text: error.response.data.original.message })
      })
    },
    async login (evt) {
      if (!formValidation(evt)) return
      this.$vm.loading({
        background: 'primary',
        color: '#fff',
        container: '#loginButton',
        scale: 0.45
      })
      try {
        await this.doLogin()
      } catch (error) {
        this.setAlertMessage({ color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' })
      }
      this.$vm.loading.close('#loginButton > .con-vm-loading')
    }
  }
}
</script>

<style lang="scss" scoped>
#login {
  margin-top: 150px;
}
.vm-input {
  color: #5b5777;
  .vm-input--icon {
    color: rgba(0,0,0,.4) !important;
  }
}
</style>
